import { defineProductDimensions, frMrgaPricingVersionDimension, frMrgaSelectedDimension } from '@orus.eu/dimensions'

import { frMrgaProductVersionDimension } from './fr-mrga-dimensions.ts'
import { frMrgaQuoteDimension } from './fr-mrga-quote-dimension.ts'

export * from './fr-mrga-dimensions.ts'
export * from './fr-mrga-exclusions.ts'
export * from './fr-mrga-fleet-dimension.ts'
export * from './fr-mrga-fleet-formula-premiums-dimension.ts'
export * from './fr-mrga-policy-item-dimensions.ts'
export * from './fr-mrga-quote-dimension.ts'

export const frMrgaDimensionsModule = defineProductDimensions({
  product: 'fr-mrga',
  family: null,
  selectionDimension: frMrgaSelectedDimension,
  productVersionDimension: frMrgaProductVersionDimension,
  pricingVersionDimension: frMrgaPricingVersionDimension,
  quoteV3Dimension: frMrgaQuoteDimension,
})
